<button #openDrawerButton type="button" command="show-modal" commandfor="rakutenAffiliateDrawer"
  class="sr-only">Open drawer</button>

<el-dialog>
  <dialog #drawerDialog id="rakutenAffiliateDrawer" aria-labelledby="rakutenAffiliateDrawer-title"
    class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
    <el-dialog-backdrop (click)="closePanel()"
      class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
    </el-dialog-backdrop>
    <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
      (click)="$event.stopPropagation()">

      <el-dialog-panel
        class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
        (click)="$event.stopPropagation()">
        <div class="relative flex h-full flex-col overflow-hidden bg-white dark:bg-zinc-900 shadow-xl rounded-xl">

          <div class="shrink-0 shout-plus-hero-gradient px-5 py-5">
            <div class="flex items-center justify-between gap-3">
              <div class="flex min-w-0 items-center gap-3">
                <div
                  class="inline-flex shrink-0 items-center justify-center rounded-full bg-white dark:bg-zinc-900 p-2 shadow-sm ring-2 ring-white ring-offset-4 ring-offset-[#BF0000]">
                  <img src="assets/images/logos/rakuten-logo.webp" alt="" class="h-10 w-10 object-contain" />
                </div>
                <h2 id="rakutenAffiliateDrawer-title" class="m-0 truncate text-base font-semibold leading-6 text-white">
                  Rakuten affiliate link
                </h2>
              </div>
              <button type="button" class="fab-button-secondary !text-white hover:!bg-white/10" (click)="closePanel()"
                aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </button>
            </div>
          </div>

          <div class="flex flex-1 min-h-0 flex-col overflow-y-auto overflow-x-hidden p-6 scrollbar-transparent">
            @if (assignment(); as ctx) {
            <div class="flex flex-col gap-4">
              <div class="flex flex-col gap-1">
                <h3 class="m-0 text-sm font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">Brief
                </h3>
                <p class="m-0 text-sm text-gray-700 dark:text-zinc-300">
                  {{ ctx.briefTitle ?? '—' }}
                </p>
              </div>

              <div class="flex flex-col gap-1.5">
                <h3 class="m-0 text-sm font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
                  Affiliate link</h3>
                @if (ctx.trackingLink; as trackingLink) {
                <div class="flex items-center gap-2">
                  <a [href]="trackingLink" target="_blank" rel="noopener noreferrer"
                    class="inline-flex min-w-0 flex-1 items-center gap-x-2 rounded-lg border border-gray-300 dark:border-zinc-600 px-3 py-2 text-sm font-medium text-gray-700 dark:text-zinc-300 hover:bg-gray-100 dark:hover:bg-zinc-800 hover:text-[#BF0000] transition"
                    [title]="trackingLink">
                    <span class="truncate">{{ trackingLink | truncate: 45 }}</span>
                  </a>
                  <button type="button"
                    class="inline-flex shrink-0 items-center justify-center rounded-lg border border-gray-300 dark:border-zinc-600 px-2.5 py-2 text-gray-700 dark:text-zinc-300 hover:bg-gray-100 dark:hover:bg-zinc-800 hover:text-[#BF0000] transition"
                    (click)="copyItem(trackingLink, 'affiliate link')" appTooltip="Copy affiliate link"
                    position="bottom" aria-label="Copy affiliate link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="size-4">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                    </svg>
                  </button>
                </div>
                } @else {
                <p class="m-0 text-sm text-gray-400">N/A</p>
                }
              </div>
            </div>
            } @else {
            <div class="flex flex-1 items-center justify-center min-h-32 py-6 text-center">
              <p class="m-0 text-sm text-gray-500 dark:text-zinc-400">
                No link details available. Close and try again.
              </p>
            </div>
            }
          </div>

          <div class="shrink-0 border-t border-gray-200 dark:border-zinc-700 px-6 py-4">
            <div class="flex items-center justify-end">
              <button type="button" class="primary-button-primary" (click)="closePanel()">
                Close
              </button>
            </div>
          </div>

        </div>
      </el-dialog-panel>
    </div>
  </dialog>
</el-dialog>
